import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';
import {ExternalConnectionControllerService, ExternalConnectionView} from '../../../../api';
import {NotificationsService} from '../../../../services/notifications/notifications.service';

export interface DisconnectDialogData {
  organisationId: number;
  connection: ExternalConnectionView;
}

/**
 * Verbindung trennen (Figma Popup 7). Mit freigegebenen Sites führt das Backend über einen Microsoft-Login
 * eines SharePoint-Admins, der die Freigaben entfernt; ohne Sites ist die Verbindung sofort getrennt.
 * Schließt mit `'done'`, wenn nichts mehr anzumelden war.
 */
@Component({
  selector: 'app-disconnect-dialog',
  templateUrl: './disconnect-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BicPopupComponent, BicButtonComponent]
})
export class DisconnectDialogComponent {
  readonly data = inject<DisconnectDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<DisconnectDialogComponent>>(MatDialogRef);
  private readonly connectionService = inject(ExternalConnectionControllerService);
  private readonly notifications = inject(NotificationsService);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly siteCount = this.data.connection.sites?.length ?? 0;
  readonly pending = this.data.connection.status !== ExternalConnectionView.StatusEnum.ACTIVE;
  busy = false;

  disconnect(): void {
    this.busy = true;
    this.connectionService.disconnectExternalConnection(this.data.organisationId, this.data.connection.id!).subscribe({
      next: start => {
        if (start.loginUrl) {
          this.redirect(start.loginUrl);
          return;
        }
        this.dialogRef.close('done');
      },
      error: err => {
        this.busy = false;
        this.notifications.showErrorMessage(err?.error?.message ?? 'Die Verbindung konnte nicht getrennt werden.');
        this.cdr.markForCheck();
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  /** Verlässt planBIC Richtung Microsoft-Login; eigene Methode, damit Tests die Weiterleitung abfangen können. */
  redirect(url: string): void {
    window.location.assign(url);
  }
}
